import showCard from "./show_card/show_card";

export default {
  show_card: showCard,
};
